export default "__VITE_ASSET__DpAbFWpO__"